export default __webpack_public_path__ + "static/media/gavin.bdc6e345.jpg";